import Splide from '@splidejs/splide';
import Classes from '../utils/custom-classes';
import FindItems from '../utils/find-items';
import CarouselTransition from '../extensions/carousel-transition';

export default class CarouselContent {
  constructor(scope) {
    const target = '[data-carousel-content]';

    FindItems(scope, target, this.create);
  }

  create(element) {
    const splide = new Splide(element, {
      type: 'loop',
      drag: true,
      arrows: false,
      slideFocus: false,
      classes: Classes
    });

    splide.on('mounted', function() {
      const image = document.querySelector('.carousel_slide.is-active .carousel_slide_image'),
        text = document.querySelector('.carousel_slide.is-active .carousel_slide_text_inner');

      image.classList.add('entered');
      text.classList.add('entered');
    });

    splide.mount({}, CarouselTransition);

    splide.on('drag pagination:updated', function(newIndex, oldIndex, destIndex) {
      const list = splide.Components.Elements.list,
        image = document.querySelector('.carousel_slide.is-active .carousel_slide_image'),
        text = document.querySelector('.carousel_slide.is-active .carousel_slide_text_inner');

      image.classList.add('hide');
      text.classList.add('exiting');
    });

    splide.on('moved pagination:mounted', function(newIndex, oldIndex, destIndex) {
      const image = document.querySelector('.carousel_slide.is-active .carousel_slide_image'),
        text = document.querySelector('.carousel_slide.is-active .carousel_slide_text_inner');

      if (newIndex !== oldIndex) {
        image.classList.add('entered');
        text.classList.add('entered');

        const prevSlide = splide.Components.Elements.getSlide(oldIndex);

        if (prevSlide) {
          const prevImage = prevSlide.slide.querySelector('.carousel_slide_image'),
            prevText = prevSlide.slide.querySelector('.carousel_slide_text_inner');

          prevImage.classList.remove('entered', 'hide');
          prevText.classList.remove('entered', 'exiting');
        }
      } else {
        image.classList.remove('hide');
        text.classList.remove('exiting');
      }
    });


  }
}
